export default __webpack_public_path__ + "static/media/jenny_hayes.73248d60.jpg";